import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Named } from '../base/named';

/**
 * Represents a folder which can group a set of concept entities such as pipelines, datasets and data flows.
 */
@Metamodel.model({
    referable: true
})
export class Folder extends Named {
    public static readonly MODEL: IModel;

    public constructor(name: string) {
        super(name);
    }
}
